import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserX = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsxs("mask", {
			id: "userXCut",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 1024,
			height: 1024,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 1024,
				height: 1024,
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M760 680l224 224M984 680l-224 224",
				stroke: "#000",
				strokeWidth: 180,
				strokeLinecap: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#userXCut)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M400 464c101.62 0 184-82.38 184-184s-82.38-184-184-184-184 82.38-184 184 82.38 184 184 184z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M72 960v-32c0-181.19 146.81-328 328-328s328 146.81 328 328v32h-656z",
				fill: "currentColor"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M760 680l224 224M984 680l-224 224",
			stroke: "currentColor",
			strokeWidth: 88,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgUserX);
export default ForwardRef;
